import { render, staticRenderFns } from "./MaterialTemplateInputItem.vue?vue&type=template&id=fa007b94&scoped=true"
import script from "./MaterialTemplateInputItem.vue?vue&type=script&lang=ts"
export * from "./MaterialTemplateInputItem.vue?vue&type=script&lang=ts"
import style0 from "./MaterialTemplateInputItem.vue?vue&type=style&index=0&id=fa007b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa007b94",
  null
  
)

export default component.exports